var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-2",attrs:{"elevation":"2","dark":"","color":"#cf1f5a"},on:{"click":function($event){return _vm.impersonateUser()}}},[_c('v-icon',{attrs:{"color":"white","dense":"","small":""}},[_vm._v("fas fa-user-ninja")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }